var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLubavFilledDropShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 66,
    height: 66,
    rx: 9.5,
    fill: "black",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 67.0209,
    height: 66.4346,
    rx: 9.5,
    fill: "#F5F5F0",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6294 36.6816C30.6294 38.8008 32.3474 40.5188 34.4667 40.5188C36.5859 40.5188 38.3039 38.8008 38.3039 36.6816C38.3039 34.5624 36.5859 32.8444 34.4667 32.8444C32.3474 32.8444 30.6294 34.5624 30.6294 36.6816Z",
    fill: "#FF5B2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5852 37.2912C54.5852 48.0648 45.5801 56.8001 34.4686 56.8001C23.3572 56.8001 14.3481 48.0648 14.3481 37.2912H27.6417C27.6417 40.9449 30.6965 43.9067 34.4689 43.9067C38.2371 43.9067 41.2918 40.9449 41.2918 37.2912H54.5852Z M14.3481 12.7617H27.617V37.2912L14.3481 37.2912L14.3481 12.7617Z",
    fill: "#367FFF",
    fillOpacity: 1,
    opacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLubavFilledDropShadow);
export default __webpack_public_path__ + "static/media/lubav-filled-drop-shadow.872e7d594cd3e5321c007193841aa77d.svg";
export { ForwardRef as ReactComponent };